import {
  Pencil,
  Trash2,
  Heart,
  UserPlus,
  Clock,
  Sparkles,
  GraduationCap,
  Users,
  Home,
  Smile,
  MapPin,
  PawPrint,
  Bell,
  ClipboardList,
  Backpack,
  BookOpen,
  Lightbulb,
  Check,
} from "lucide-react";

const ICONS = {
  pencil: Pencil,
  trash: Trash2,
  heart: Heart,
  "user-plus": UserPlus,
  clock: Clock,
  sparkles: Sparkles,
  "graduation-cap": GraduationCap,
  users: Users,
  home: Home,
  smile: Smile,
  "map-pin": MapPin,
  paw: PawPrint,
  bell: Bell,
  clipboard: ClipboardList,
  backpack: Backpack,
  book: BookOpen,
  lightbulb: Lightbulb,
};

// Tailwind-safe color tokens (must be present at build time as full classnames).
const PALETTES = {
  yellow:  { bg: "bg-yellow-50",  iconBg: "bg-yellow-400",  ring: "ring-yellow-200",  ringSel: "ring-yellow-500",  hoverRing: "hover:ring-yellow-400" },
  orange:  { bg: "bg-orange-50",  iconBg: "bg-orange-400",  ring: "ring-orange-200",  ringSel: "ring-orange-500",  hoverRing: "hover:ring-orange-400" },
  rose:    { bg: "bg-rose-50",    iconBg: "bg-rose-400",    ring: "ring-rose-200",    ringSel: "ring-rose-500",    hoverRing: "hover:ring-rose-400" },
  sky:     { bg: "bg-sky-50",     iconBg: "bg-sky-400",     ring: "ring-sky-200",     ringSel: "ring-sky-500",     hoverRing: "hover:ring-sky-400" },
  amber:   { bg: "bg-amber-50",   iconBg: "bg-amber-400",   ring: "ring-amber-200",   ringSel: "ring-amber-500",   hoverRing: "hover:ring-amber-400" },
  emerald: { bg: "bg-emerald-50", iconBg: "bg-emerald-400", ring: "ring-emerald-200", ringSel: "ring-emerald-500", hoverRing: "hover:ring-emerald-400" },
  violet:  { bg: "bg-violet-50",  iconBg: "bg-violet-400",  ring: "ring-violet-200",  ringSel: "ring-violet-500",  hoverRing: "hover:ring-violet-400" },
};

/**
 * ChoiceCard — big, kid-friendly tappable card with icon + label.
 * Used by Mission 1, 3 and 4 to replace text-heavy inputs.
 */
export default function ChoiceCard({
  icon = "sparkles",
  label,
  selected = false,
  color = "yellow",
  onSelect,
  testId,
  size = "md", // "md" | "lg"
}) {
  const Icon = ICONS[icon] || Sparkles;
  const p = PALETTES[color] || PALETTES.yellow;
  const padding = size === "lg" ? "p-5 sm:p-6" : "p-4";
  const iconSize = size === "lg" ? "w-14 h-14" : "w-12 h-12";
  const iconInner = size === "lg" ? "w-7 h-7" : "w-6 h-6";
  const labelSize = size === "lg" ? "text-base sm:text-lg" : "text-base";

  return (
    <button
      type="button"
      onClick={onSelect}
      className={`relative ${padding} rounded-3xl text-left transition-all flex flex-col gap-3 ring-2 ${
        selected
          ? `${p.bg} ${p.ringSel} shadow-lg -translate-y-0.5`
          : `bg-white ${p.ring} ${p.hoverRing} hover:shadow-md hover:-translate-y-0.5`
      }`}
      aria-pressed={selected}
      data-testid={testId}
    >
      <div className={`${iconSize} ${p.iconBg} rounded-2xl flex items-center justify-center text-white shadow-sm`}>
        <Icon className={iconInner} />
      </div>
      <p className={`${labelSize} font-bold text-gray-900 leading-snug`}>{label}</p>
      {selected && (
        <span
          className={`absolute top-3 right-3 ${p.iconBg} text-white w-7 h-7 rounded-full flex items-center justify-center shadow`}
          aria-hidden="true"
        >
          <Check className="w-4 h-4" />
        </span>
      )}
    </button>
  );
}
